import React from 'react'

const logooutIcon = () => {
	return (
		<svg width={34} height={29} viewBox='0 0 34 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g fill='currentColor'>
				<path d='M3.203 25.778V3.222h14.414v4.834c0 .427.168.837.469 1.139a1.596 1.596 0 002.265 0c.3-.302.469-.712.469-1.14V1.612c0-.427-.17-.837-.47-1.14A1.597 1.597 0 0019.218 0H1.602C1.177 0 .769.17.469.472.17.774 0 1.184 0 1.612v25.777c0 .427.169.837.47 1.14.3.301.707.471 1.132.471h17.616c.425 0 .832-.17 1.133-.472.3-.302.469-.712.469-1.14v-6.444c0-.427-.17-.837-.47-1.139a1.597 1.597 0 00-2.264 0c-.3.302-.47.712-.47 1.14v4.833H3.204z' />
				<path d='M33.584 13.42a1.603 1.603 0 00-.305-.273l-6.95-6.284a1.595 1.595 0 00-2.19.175 1.617 1.617 0 00.044 2.21l4.02 3.657H16.014c-.425 0-.832.17-1.132.472a1.616 1.616 0 000 2.278c.3.302.707.472 1.132.472h12.188l-4.02 3.641a1.618 1.618 0 00.988 2.813c.425.022.841-.126 1.158-.412l6.95-6.3a1.606 1.606 0 00.72-1.153 1.621 1.621 0 00-.415-1.296z' />
			</g>
		</svg>
	)
}

export default logooutIcon
